import { render } from "./success-alert-mobile.vue?vue&type=template&id=e21783fa&scoped=true"
import script from "./success-alert-mobile.vue?vue&type=script&lang=js"
export * from "./success-alert-mobile.vue?vue&type=script&lang=js"

import "./success-alert-mobile.vue?vue&type=style&index=0&id=e21783fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e21783fa"

export default script